export const DEFAULT_CONFIG = {
    settings: {
        baseCurrency: "CAD",
        defaultCurrency: "CAD",
        currency: "CAD",
        siteTitle: "OMNIVASO",
        favicon: "/favicon.ico",
        navLinks: [
            { text: "About", url: "/about" },
            { text: "Shows", url: "/shows" },
            { text: "Music", url: "/music" },
            { text: "Contact", url: "/contact" }
        ],
        primaryColor: "#ff0000",
        secondaryColor: "#000000",
        tertiaryColor: "#f59e0b",
        pageBackground: "#2a0a0a",

        pageBgMode: "solid", pageGradientStart: "#2a0a0a", pageGradientMid: "", pageGradientEnd: "#1a0505", pageGradientAngle: "180",
        pageGradientAnimate: false, pageGradientAnimateSpeed: "8",
        pageBackgroundImage: "", pageBackgroundSize: "cover", pageBackgroundPosition: "center", pageBackgroundRepeat: "no-repeat",
        pageBgDesaturate: 0, pageBgFilter: "none", pageBgOverlayBlendMode: "normal",
        primaryBgMode: "solid", primaryGradientStart: "#ff0000", primaryGradientMid: "", primaryGradientEnd: "#cc0000", primaryGradientAngle: "135",
        heroBgMode: "solid", heroGradientStart: "#2a0a0a", heroGradientMid: "", heroGradientEnd: "#000000", heroGradientAngle: "135",
        heroGradientAnimate: false, heroGradientAnimateSpeed: "8",

        featuredBgColor: "#1a0505",
        featuredTextColor: "#ffffff",
        featuredHeading: "Featured Projects",
        viewAllText: "View All",

        readMoreText: "Read More →",
        readMoreColor: "primary",
        readMoreWeight: "bold",
        readMoreStyle: "normal",

        headerOverlayHero: false,
        headerBorderBottomWidth: "0px", headerBorderBottomColor: "#000000", headerBorderBottomStyle: "solid",
        footerBorderTopWidth: "1px", footerBorderTopColor: "#444444", footerBorderTopStyle: "solid",

        buttonRadius: "4px", buttonBorderWidth: "0px", buttonBorderColor: "#000000", buttonBorderStyle: "solid",
        buttonFontWeight: "bold", buttonFontSize: "1rem", buttonFontFamily: "", buttonTextColor: "#ffffff", buttonHoverTextColor: "",
        buttonTextTransform: "none", buttonLetterSpacing: "normal", buttonPadding: "12px 24px", buttonMargin: "0px", buttonWidth: "auto",
        buttonHoverBg: "", buttonHoverBorderColor: "", buttonHoverEffect: "none", buttonHoverShadowColor: "", buttonTransition: "all 0.25s ease", buttonCustomCss: "",
        imageRadius: "8px", imageBorderWidth: "0px", imageBorderColor: "#000000", imageBorderStyle: "solid", imagePadding: "0px", imageBg: "transparent",
        imageDesaturate: 0, imageFilter: "none", imageHoverFilter: "none", imageClickInteraction: "none", imageCustomFilter: "", imageTint: "", imageTintOpacity: 0.4, imageTintBlendMode: "multiply", imageTransitionDuration: "0.4s", imageTransitionTiming: "cubic-bezier(0.4, 0, 0.2, 1)",
        bgHoverInteraction: "none", bgClickInteraction: "none", bgTransitionDuration: "0.5s", bgTransitionTiming: "cubic-bezier(0.4, 0, 0.2, 1)",
        heroBgHoverInteraction: "none", heroBgClickInteraction: "none", heroBgTransitionDuration: "0.5s", heroBgTransitionTiming: "cubic-bezier(0.4, 0, 0.2, 1)",
        shopCardImageDesaturate: 0, shopCardImageFilter: "none", shopCardImageHoverFilter: "none", shopCardImageClickInteraction: "none", shopCardImageCustomFilter: "", shopCardImageTint: "", shopCardImageTintOpacity: 0.4, shopCardImageTintBlendMode: "multiply", shopCardImageTransitionDuration: "0.4s", shopCardImageTransitionTiming: "cubic-bezier(0.4, 0, 0.2, 1)",
        shopProductCardImgBg: "transparent", shopProductCardImgBorder: "none", shopProductCardImgRadius: "0px", shopProductCardImgPadding: "0px",

        headerShadowPreset: "none", headerShadowCustom: "", headerShadowColor: "#000000", headerShadowBlur: "0px", headerShadowX: "0px", headerShadowY: "0px", headerShadowSpread: "0px", headerShadowInset: false,
        headerSpaceBelow: "80px",
        buttonShadowColor: "#000000", buttonShadowBlur: "0px", buttonShadowX: "0px", buttonShadowY: "0px", buttonShadowInset: false,
        imageShadowColor: "#000000", imageShadowBlur: "10px", imageShadowX: "0px", imageShadowY: "4px", imageShadowInset: false,

        footerMaxWidth: "",
        footerPaddingLeftRight: "",

        footerLayout: "columns",
        footerColumnGap: "24px",
        footerAlignItems: "flex-start",
        footerBgGradient: "",
        footerCustomCss: "",
        mobileFooterLayout: "stack",
        mobileFooterTextAlign: "inherit",
        mobileFooterPaddingTopBottom: "24px",
        mobileFooterPaddingLeftRight: "16px",
        mobileFooterPaddingTop: "",
        mobileFooterPaddingBottom: "",
        mobileFooterPaddingLeft: "",
        mobileFooterPaddingRight: "",
        mobileFooterColumnGap: "20px",
        mobileFooterColumnMarginBottom: "16px",
        mobileFooterHeadingFontSize: "",
        mobileFooterHeadingAlign: "inherit",
        mobileFooterBodyFontSize: "",
        mobileFooterSocialsAlign: "inherit",
        mobileFooterSocialsSize: "20px",
        mobileFooterCustomCss: "",
        hideFooterOnMobile: false,

        quoteStyle: "classic",
        quoteBorderColor: "",
        quoteBgColor: "",
        quoteTextColor: "",
        quoteFontSize: "",

        collapsibleVerticalAlign: "center",
        collapsibleIconType: "standard",
        globalCollapseMobileDefault: "inherit",
        globalCollapseBtnVerticalAlign: "center",
        globalCollapseBtnIconType: "standard",
        globalCollapseBtnBorderWidth: "1px",
        globalCollapseBtnBorderStyle: "solid",
        globalCollapseBtnBorderColor: "#3b82f6",

        searchLayout: "modal",
        searchBgColor: "#0f172a",
        searchTextColor: "#f8fafc",
        searchAccentColor: "#3b82f6",
        searchBorderColor: "rgba(255, 255, 255, 0.15)",
        searchRadius: "14px",
        searchGlassmorphic: true,
        showSearchInHeader: false,
        searchShortcutEnabled: false,
        showSearchFab: false,
        searchPlaceholder: "Type to search products, articles, pages...",
        headerSearchButtonText: "🔍 Search ⌘K"
    },
    typography: {
        fontFamily: "Inter, system-ui, sans-serif",
        h1: { size: "2.75rem", lineHeight: "1.2", tracking: "-0.03em", color: "#f4f4f5" },
        h2: { size: "2rem", lineHeight: "1.3", tracking: "-0.02em", color: "#e4e4e7" },
        body: { size: "1.05rem", lineHeight: "1.6", tracking: "0em", color: "#a1a1aa" }
    },
    customFonts: [],
    hero: {
        title: "Welcome to OMNIVASO",
        subtitle: "The ultimate free and scalable LIVE EDIT website builder. No code required. E-commerce equipped. Ask about our Unlimited Edits option.",
        buttons: [
            { text: "⚡ Claim Your Site", link: "/#claim", variant: "tertiary" },
            { text: "🎮 Try Live Demo", link: "/?demo=true", variant: "secondary" },
            { text: "🛍️ View Product Pages", link: "/shop", variant: "primary" }
        ],
        backgroundColor: "#090d16",
        textColor: "#ffffff",
        backgroundImage: "",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        foregroundImage: "",
        imageWidth: "300px",
        titleAlign: "center",
        subtitleAlign: "center",
        buttonsAlign: "center",
        titleTextShadowPreset: "none",
        titleTextShadowCustom: "",
        titleTextGradientMode: "solid",
        titleTextGradientStart: "#3b82f6",
        titleTextGradientEnd: "#9333ea",
        titleTextGradientAngle: "135",
        subtitleTextShadowPreset: "none",
        subtitleTextShadowCustom: "",
        subtitleTextGradientMode: "solid",
        subtitleTextGradientStart: "#3b82f6",
        subtitleTextGradientEnd: "#9333ea",
        subtitleTextGradientAngle: "135",
        overlayOpacity: 0.4,
        overlayColor: "#000000",
        overlayAlways: false,
        overlayType: "solid",
        overlayGradientAngle: "180",
        overlayGradientStart: "#000000",
        overlayGradientEnd: "#000000",
        overlayGradientStartOpacity: 0.4,
        overlayGradientEndOpacity: 0,
        carouselEnabled: false,
        carouselImages: [],
        carouselInterval: 5,
        carouselFadeDuration: "1s",
        carouselFadeEasing: "ease-in-out",
        carouselAutoplay: true,
        carouselPauseOnHover: true,
        carouselEffect: "crossfade",
        carouselKenBurns: false,
        carouselKenBurnsScale: "1.08",
        carouselBgSize: "cover",
        carouselBgPosition: "center",
        carouselBgRepeat: "no-repeat",
        carouselOverlayColor: "#000000",
        carouselOverlayOpacity: 0.4,
        carouselTint: "",
        carouselTintOpacity: 0.4,
        carouselTintBlendMode: "multiply",
        carouselDesaturate: 0,
        carouselFilter: "none",
        carouselShowArrows: true,
        carouselArrowStyle: "circle",
        carouselArrowColor: "#ffffff",
        carouselArrowBg: "rgba(0, 0, 0, 0.45)",
        carouselArrowHoverColor: "#ffffff",
        carouselArrowHoverBg: "rgba(0, 0, 0, 0.8)",
        carouselArrowSize: "42px",
        carouselArrowVisibility: "always",
        carouselShowDots: true,
        carouselDotStyle: "dots",
        carouselDotColor: "rgba(255, 255, 255, 0.45)",
        carouselActiveDotColor: "#3b82f6",
        carouselDotSize: "10px",
        carouselDotPosition: "bottom-center",
        carouselDotBackdrop: false,
        carouselCustomCss: ""
    },
    sections: [
        {
            id: "human-creativity",
            title: "Human Creativity & Integrity",
            backgroundColor: "#1e293b",
            textColor: "#ffffff",
            heading: "🎨 Human Creativity and Integrity Ensured",
            subHeading: "",
            minHeight: "auto",
            padding: "3rem 2rem",
            type: "columns",
            columns: [
                {
                    id: "col-disclaimer",
                    heading: "Engineered for Real Creators, Not AI Slop",
                    text: "<p><strong>Disclaimer:</strong> OMNIVASO is NOT one of those novelty systems that uses AI prompts that result in random guesses to show you designs that were ‘borrowed’ and blended from hard working humans.</p><p>We’re experts in crafting both hand-built sites from scratch and CMS sites, working for over 20 years in WordPress, Drupal, Joomla!, Squarespace and Shopify. When the AI boom hit, we used it for good, capitalizing on the resources and building OMNIVASO to modernize site development based on our years of experience.</p><p>Built using Antigravity and Cursor IDEs with some in-depth help from Gemini and Claude Code, we were able to develop an extremely fast and reliable site that embraces Human Creativity, and ensures code integrity, not slop.</p>",
                    width: 12
                }
            ]
        },
        {
            id: "features",
            title: "Engine Highlights",
            backgroundColor: "#090d16",
            textColor: "#ffffff",
            heading: "⚡ Why Choose OMNIVASO?",
            subHeading: "Everything you need to build, customize, and scale blazing-fast websites.",
            minHeight: "auto",
            padding: "4rem 2rem",
            type: "columns",
            columns: [
                {
                    id: "feat-1",
                    heading: "🎨 Live Theming for EASY EDITS",
                    text: "The easiest. Just click to edit text, change layouts, colours, add gradients, and animate elements for beautiful transitions live in the frontend. True WYSIWYG editing (What You See Is What You Get). Try it for yourself by clicking the ‘Try Live Demo’ feature above.",
                    width: 4
                },
                {
                    id: "feat-2",
                    heading: "⚡ 1-Click Deploy",
                    text: "Seamlessly deploy logic updates without ever overwriting client data. We ensure consistent and automatic updates with one-click maintenance to maintain security and keep up with the changing times.",
                    width: 4
                },
                {
                    id: "feat-3",
                    heading: "📄 Add Custom Pages",
                    text: "Effortlessly create pages with a HERO section, Text, Gallery, Google Ads, Newsletter, and an Events Calendar. Or take advantage of the simplicity of OMNIVASO to quickly and easily build a landing page in combination within your existing website. Enable the e-commerce module for seamless product page integration without requiring separate 3rd party plugins.",
                    width: 4
                },
                {
                    id: "feat-4",
                    heading: "🎯 Custom CSS & Layouts",
                    text: "Customize your pages with animation, gradients, parallax scrolling, or use custom CSS injections for complete control. Manage site responsiveness (how your site will look on mobile) without ever having to leave your place on the page.",
                    width: 4
                },
                {
                    id: "feat-5",
                    heading: "🧩 Add Function Modules",
                    text: "Including full e-commerce shop and cart system, and Newsletter campaigns with your favourite provider including Mail Chimp and Brevo. All modules are built for use with OMNIVASO, for stress-free operation with no maintenance and no 3rd party plugin conflicts.",
                    width: 4
                },
                {
                    id: "feat-6",
                    heading: "🚀 SEO Made Easy",
                    text: "The most difficult part of SEO is the time commitment. All of the necessary tools are readily available in the OMNIVASO Dashboard to make the process as painless as possible, along with a checklist and built-in evaluation to keep you on track. Take advantage of our SEO tutorials, or connect with us to provide the best (least amount of work for you) experience possible.",
                    width: 4
                }
            ]
        },
        {
            id: "ready-to-begin",
            title: "Ready to Begin",
            backgroundColor: "#1e293b",
            textColor: "#ffffff",
            heading: "💳 Ready to begin?",
            subHeading: "OMNIVASO was built to receive your creative inputs.",
            minHeight: "auto",
            padding: "4rem 2rem",
            type: "columns",
            columns: [
                {
                    id: "col-ready",
                    heading: "Transparent, Flexible Plans for Every Creator",
                    text: "<p>Start by creating your site <a href=\"/#claim\" style=\"color:#60a5fa;font-weight:bold;\">on the OMNIVASO Engine</a> with our <strong>Free / Starter</strong> plan ($0 with 100 free edits to build, free subdomain, community support, and 2% e-commerce fee). When you are ready to scale, upgrade to <strong>Creator / Artist</strong> ($12/mo or $99/yr for custom domain connection, unlimited edits, basic e-commerce for 10 products, and no platform transaction fee), <strong>Business / Shop</strong> ($24/mo or $199/yr for unlimited products, inventory tracking, newsletter integration, and priority backups), or <strong>Agency / Pro</strong> ($49/mo for multi-site management, client billing markup, and white-label dashboard).</p><p>Tutorials are available for every step of the way. If you need a helping hand, or just want a site built for you to easily edit, contact the cleverologists at MAD CURIOUS (<a href=\"mailto:cleverologist@madcurious.com\" style=\"color:#60a5fa;\">cleverologist@madcurious.com</a>). Want to see sites that have been developed using the OMNIVASO engine? Go to <a href=\"https://madcurious.com/\" target=\"_blank\" style=\"color:#60a5fa;font-weight:bold;\">https://madcurious.com/</a></p>",
                    width: 12
                }
            ]
        },
        {
            id: "security",
            title: "Security Architecture",
            backgroundColor: "#090d16",
            textColor: "#ffffff",
            heading: "🛡️ Ironclad Security Architecture",
            subHeading: "Engineered for zero-trust client environments. Complete database immunity, input sanitization, and build-time artifact security.",
            minHeight: "auto",
            padding: "4rem 2rem",
            type: "columns",
            columns: [
                {
                    id: "sec-1",
                    heading: "🔐 Build-Time Artifact Protection",
                    text: "Automated post-build security processes sanitize production web distribution artifacts and sensitive server configuration files automatically.",
                    width: 4
                },
                {
                    id: "sec-2",
                    heading: "⚔️ XSS & Script Injection Shield",
                    text: "Live input sanitization strips executable scripts, javascript: schemes, and event handler payloads automatically.",
                    width: 4
                },
                {
                    id: "sec-3",
                    heading: "⚡ SQL Injection Immunity",
                    text: "By leveraging static JSON structures and headless client state, OMNIVASO is naturally immune to traditional database SQL injection attacks.",
                    width: 4
                }
            ]
        }
    ],
    footer: [],
    articles: [],
    themes: [],
    pages: [],
    socials: [],
    seo: {
        metaTitle: "",
        metaDescription: "",
        favicon: "/favicon.ico",
        appleTouchIcon: "/apple-touch-icon.png"
    },
    modules: {
        shipping: {
            enabled: true,
            storeCountry: 'Canada',
            storePostalCode: 'M5V 2T6',
            allowLocalPickup: true,
            pickupLocationName: 'Main Store Warehouse',
            pickupAddress: '123 Commerce Way, Toronto, ON',
            freeShippingEnabled: true,
            customsDisclosureEnabled: true,
            customsNoticeText: 'International orders may be subject to customs duties, import taxes, or brokerage fees levied by the destination country upon delivery (DDU).',
            handlingFee: 0.00,
            zones: {
                domestic: {
                    enabled: true,
                    freeShippingThreshold: 100.00,
                    enableFreeShipping: true,
                    perItemFee: 0.00,
                    services: [
                        { id: 'dom_std', name: 'Standard Domestic Shipping', cost: 10.00, estimatedDays: '3–5 business days', isDefault: true, enabled: true },
                        { id: 'dom_exp', name: 'Express Expedited Shipping', cost: 18.00, estimatedDays: '1–2 business days', enabled: true },
                        { id: 'dom_pickup', name: 'Local In-Store Pickup', cost: 0.00, estimatedDays: 'Ready in 24 hours', isPickup: true, enabled: true }
                    ]
                }
            }
        },
        ecommerce: {
            id: 'ecommerce',
            enabled: false,
            isLocked: true,
            licenseKey: '',
            licenseTier: 'E-Commerce Pro Suite',
            name: 'E-Commerce Shop & Cart Engine',
            description: 'Full online store functionality including product catalog management, dynamic categories, shopping cart state, and order management.',
            version: '1.0.0',
            author: 'Omnivaso Commerce Suite'
        },
        eventTicketing: {
            id: 'eventTicketing',
            enabled: true,
            isLocked: false,
            addOnPrice: '$49/mo',
            licenseKey: 'OMNI-TICKETS-PRO-ACTIVATED',
            licenseTier: 'Event Ticketing & Pass Pro Suite',
            slug: 'events',
            currency: 'USD',
            name: 'Event Ticketing & QR Pass Engine',
            description: 'Sell custom event passes, issue digital QR codes, set sliding scale pricing, and manage attendee check-ins.'
        },
        mailService: {
            id: 'mailService',
            enabled: true,
            provider: 'mailchimp', // 'mailchimp' | 'constant_contact' | 'brevo' | 'webhook' | 'local'
            name: 'Mailchimp, Constant Contact & Brevo Email Marketing',
            description: 'Connect Mailchimp, Constant Contact, Brevo (Sendinblue), Zapier webhooks, or native local lead capture for high-converting email newsletter collection.',
            apiKey: '',
            listId: '',
            datacenter: 'us21',
            constantContactAccessToken: '',
            constantContactListId: '',
            brevoApiKey: '',
            brevoListId: '',
            webhookUrl: '',
            formTitle: 'Subscribe to Our Newsletter',
            formSubtitle: 'Get the latest news, updates and exclusive offers delivered straight to your inbox.',
            buttonText: 'Subscribe Now',
            placeholderText: 'Enter your email address...',
            successMessage: '🎉 Thank you for subscribing! Check your inbox for confirmation.',
            doubleOptIn: true,
            collectName: true,
            requireGdprConsent: false,
            gdprText: 'I agree to receive email updates and newsletters.',
            subscribers: [
                { id: 'sub_1', email: 'demo.subscriber@omnivaso.com', name: 'Alex Rivera', provider: 'mailchimp', status: 'subscribed', createdAt: '2026-07-29T10:00:00.000Z' },
                { id: 'sub_2', email: 'elena.marketing@example.com', name: 'Elena Rostova', provider: 'constant_contact', status: 'subscribed', createdAt: '2026-07-28T16:30:00.000Z' },
                { id: 'sub_3', email: 'marcus.vance@brevo-user.com', name: 'Marcus Vance', provider: 'brevo', status: 'subscribed', createdAt: '2026-07-29T12:15:00.000Z' }
            ]
        },
        canadianTax: {
            id: 'canadianTax',
            enabled: true,
            storeProvince: 'ON',
            applyToAllProvinces: true,
            applyOnlyInStoreProvince: false,
            showTaxBreakdown: true,
            taxIncludedInPrice: false,
            roundingMode: 'standard',
            customRates: {},
            registrationNumber: ''
        },
        additionalServices: {
            id: 'additionalServices',
            enabled: true,
            title: 'Additional Services & Charges',
            description: 'Configure mandatory or optional auxiliary charges such as Bottle Deposit Fees, Environmental Handling Fees (EHF), Gift Wrapping, and Custom Surcharges.',
            bottleDeposit: {
                enabled: true,
                name: 'Bottle Deposit Fee',
                defaultFeePerBottle: 0.10,
                taxable: false,
                exemptFromDiscounts: true,
                applyMode: 'tagged_or_category',
                applicableCategories: [
                    'Beverages', 'Drinks', 'Wine', 'Beer', 'Spirits', 
                    'Juice', 'Water', 'Cider', 'Soda', 'Liquor', 'Cold Drinks',
                    'Alcohol', 'Kombucha', 'Bottles', 'Beverage'
                ],
                applicableTags: [
                    'bottle', 'bottles', 'beverage', 'drink', 'beer', 'wine', 'cider', 'soda', 'can', 'cans', 'deposit', 'recyclable'
                ],
                refundNotice: 'Statutory container deposit is 100% refundable at any authorized local recycling depot.'
            },
            services: [
                {
                    id: 'srv_gift_wrap',
                    name: '🎁 Premium Gift Wrapping & Card',
                    description: 'Elegantly packaged in a gift box with a satin bow and a handwritten message card.',
                    type: 'fixed_order',
                    amount: 5.00,
                    mode: 'optional',
                    enabled: true,
                    taxable: true,
                    allowCustomerNote: true,
                    notePlaceholder: 'Enter custom gift card message (optional)...'
                },
                {
                    id: 'srv_fragile_insulation',
                    name: '🧊 Temperature-Controlled / Fragile Packaging',
                    description: 'Thermal insulated bubble-wrap and food-safe ice chill packs to guarantee product freshness and protection.',
                    type: 'fixed_order',
                    amount: 3.50,
                    mode: 'optional',
                    enabled: true,
                    taxable: true,
                    allowCustomerNote: false
                },
                {
                    id: 'srv_eco_handling',
                    name: '♻️ Environmental Handling Fee (EHF)',
                    description: 'Statutory electronics and eco recycling stewardship fee.',
                    type: 'per_item',
                    amount: 0.40,
                    mode: 'mandatory',
                    enabled: false,
                    taxable: true,
                    applyMode: 'tagged_or_category',
                    applicableCategories: ['Electronics', 'Hardware', 'Appliances', 'Batteries']
                }
            ]
        },
        editQuota: {
            id: 'editQuota',
            enabled: true,
            planTier: 'free_starter', // 'free_starter' | 'creator_artist' | 'business_shop' | 'agency_pro'
            monthlyLimit: 100,
            editsUsedThisMonth: 0,
            bonusCredits: 0,
            billingCycleAnchor: new Date().toISOString(),
            annualUnlimitedExpires: null,
            tiers: [
                {
                    id: 'free_starter',
                    name: 'Free / Starter',
                    priceMonthly: '$0',
                    priceAnnual: '$0',
                    idealFor: 'Prototyping, hobbyists',
                    inclusions: ['Free subdomain', '100 edits to build', 'Community support', '2% e-commerce fee']
                },
                {
                    id: 'creator_artist',
                    name: 'Creator / Artist',
                    priceMonthly: '$12/mo',
                    priceAnnual: '$99/yr',
                    idealFor: 'Portfolios, coffee shops, small sites',
                    inclusions: ['Custom domain connection', 'Unlimited edits', 'Basic e-commerce (10 products)', 'No platform transaction fee']
                },
                {
                    id: 'business_shop',
                    name: 'Business / Shop',
                    priceMonthly: '$24/mo',
                    priceAnnual: '$199/yr',
                    idealFor: 'Full e-commerce, active brands',
                    inclusions: ['Unlimited products', 'Inventory tracking', 'Newsletter integration (Mailchimp/Brevo)', 'Priority backups']
                },
                {
                    id: 'agency_pro',
                    name: 'Agency / Pro',
                    priceMonthly: '$49/mo',
                    priceAnnual: '$49/mo',
                    idealFor: 'Freelancers, web designers',
                    inclusions: ['Multi-site management', 'Client billing markup', 'White-label dashboard']
                }
            ],
            masterPlatformBilling: {
                developerStripePublishableKey: 'pk_live_omnivaso_master_dev_key',
                developerStripeCheckoutUrl: '', // e.g. https://buy.stripe.com/your_master_credits_link
                developerPaypalEmail: 'developer-payouts@omnivaso.com',
                developerBankPayoutInfo: 'Direct Developer Platform Payouts'
            },
            transactionHistory: [
                { id: 'tx_init', type: 'quota_grant', description: 'Initial Edit Allowance (100 Edits)', amount: 100, date: new Date().toISOString() }
            ]
        },
        agencyUpsell: {
            enabled: true,
            resellerMode: false,
            agencyName: 'Mad Curious',
            expertTitle: 'Cleverologist',
            buttonLabel: 'Hire a Cleverologist',
            contactEmail: 'cleverologist@madcurious.com',
            bookingUrl: 'https://madcurious.com/',
            portfolioUrl: 'https://madcurious.com/',
            tagline: 'Programmatic Design Sprints & Expert Support',
            description: 'Stuck on custom CSS, SEO optimization, or store migration? Partner with Mad Curious cleverologists for fast, turnkey design sprints.',
            contextualTriggers: {
                enabled: true,
                cssTrigger: true,
                seoTrigger: true,
                taxTrigger: true
            },
            packages: [
                {
                    id: 'site_polish',
                    name: 'Site Polish Package',
                    price: '$199–$499',
                    priceNumeric: 299,
                    idealFor: 'Design review, mobile polish & typography',
                    description: 'A designer reviews layout, mobile responsiveness, visual hierarchy, and typography polish.',
                    turnaround: '24–48 Hours',
                    badge: 'MOST POPULAR',
                    badgeColor: '#10b981',
                    contextualTag: 'css_design',
                    enabled: true,
                    inclusions: [
                        'Full desktop & mobile layout audit',
                        'Custom typography & visual hierarchy tune-up',
                        'Mobile viewport responsiveness fixes',
                        'Hero section aesthetic polish',
                        'Post-sprint video walkthrough'
                    ]
                },
                {
                    id: 'seo_speed_audit',
                    name: 'SEO & Speed Audit',
                    price: '$150',
                    priceNumeric: 150,
                    idealFor: 'Search rankings, Core Web Vitals, Schema',
                    description: 'Schema markup setup, local SEO optimization, meta tag audit, and performance tuning.',
                    turnaround: '24 Hours',
                    badge: 'HIGH ROI',
                    badgeColor: '#3b82f6',
                    contextualTag: 'seo',
                    enabled: true,
                    inclusions: [
                        'Structured JSON-LD Schema markup setup',
                        'Title & meta description optimization',
                        'Core Web Vitals & PageSpeed audit',
                        'OpenGraph & Twitter social card verification',
                        'Search Console indexing checklist'
                    ]
                },
                {
                    id: 'store_migration',
                    name: 'Store Migration',
                    price: '$299',
                    priceNumeric: 299,
                    idealFor: 'Moving from Shopify, Etsy, WooCommerce',
                    description: 'Moving an existing store from Shopify/Etsy over to OMNIVASO with zero catalog loss.',
                    turnaround: '2–3 Days',
                    badge: 'ZERO HEADACHE',
                    badgeColor: '#8b5cf6',
                    contextualTag: 'ecommerce_tax',
                    enabled: true,
                    inclusions: [
                        'Product catalog & variant export/import',
                        'High-res imagery & gallery transfer',
                        'Category & collection structuring',
                        'Payment gateway & tax setup verification',
                        'Cart checkout test run & cutover guidance'
                    ]
                }
            ],
            leadsHistory: []
        }
    }
};
